import { Directive, ComponentRef, Input, OnDestroy,  ViewContainerRef, OnChanges, SimpleChanges, ChangeDetectorRef, Output, EventEmitter, Injector } from '@angular/core';
import { DynamicOutletService } from '../../dynamic-outlet.service';

@Directive({
  selector: '[awpDynamicOutlet]',
})
export class DynamicContentOutletDirective implements OnChanges, OnDestroy {

  private component: ComponentRef<{}>;

  @Input('awpDynamicOutlet') componentName: string;

  @Output() activated = new EventEmitter<any>();
  @Output() deactivated = new EventEmitter<any>();

  constructor(
    private viewContainerRef: ViewContainerRef,
    private dynamicOutletService: DynamicOutletService,
    private changeDectectorRef: ChangeDetectorRef,
    private injector: Injector) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.componentName) {
      this.destroyComponent();

      if (changes.componentName.currentValue != null
        && changes.componentName.currentValue !== "") {
          this.createComponent(changes.componentName.currentValue);
        }
    }
  }

  ngOnDestroy() {
    this.destroyComponent();
  }

  private createComponent(componentName: string): void {

    let createComponentName = componentName;

    if (componentName.includes(':')) {
      const parts = componentName.split(':');
      createComponentName = parts[0]; // Get first part;
    }

    this.dynamicOutletService.getComponent(createComponentName, this.injector)
      .then(component => {
        this.component = component;
        this.viewContainerRef.insert(component.hostView);
        this.changeDectectorRef.markForCheck();
        this.activated.emit(this.component.instance);
      });
  }

  private destroyComponent(): void {
    if (this.component) {
      this.deactivated.emit(this.component.instance);
      this.component.destroy();
      this.component = null;
    }
  }
}